export enum EExerciseType {
  FLS = 1,
  FREE = 2
}
